var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header app__header"},[_c('div',{staticClass:"app__header__logo",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{attrs:{"src":require("../assets/img/vpackslogo.png"),"alt":"V-Packs logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }